"use client";

import React from "react";
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  Stack,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

const AccountsHeader = ({ month, setMonth, year, setYear, search, setSearch }) => {
  const handleDateChange = (newValue) => {
    if (!newValue) return;
    setMonth(newValue.format("MMMM")); 
    setYear(newValue.year());         
  };

  return (
    <Box sx={{ mb: { xs: 3, sm: 4, md: 6 }, px: 0 }}>
      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={{ xs: 2, md: 3 }}
        alignItems={{ xs: "flex-start", md: "center" }}
        justifyContent="space-between"
      >
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            variant="h4"
            fontWeight="bold"
            sx={{
              color: (t) => (t.palette.mode === "dark" ? "#7ee2a8" : "#007a52"),
              fontSize: { xs: "1.4rem", sm: "1.6rem", md: "2rem" },
              lineHeight: 1.2,
            }}
          >
            Accounts Dashboard
          </Typography>

          <Typography
            variant="body2"
            sx={{
              color: (t) => (t.palette.mode === "dark" ? "#7ee2a8" : "#007a52"),
              mt: 0.5,
              wordBreak: "break-word",
            }}
          >
            Reporting Month: <strong>{month} {year}</strong> • Generated on:{" "}
            <strong>{dayjs().format("DD/MM/YYYY")}</strong>
          </Typography>
        </Box>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={1.5}
          sx={{
            flex: 1,
            width: "100%",
            justifyContent: { xs: "flex-start", md: "flex-end" },
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              views={["year", "month"]}
              label="Select Month & Year"
              value={dayjs(`${year}-${month}-01`)}
              onChange={handleDateChange}
              slotProps={{
                textField: {
                  size: "small",
                  sx: {
                    minWidth: { xs: "100%", sm: 200 },
                    "& .MuiOutlinedInput-root": {
                      bgcolor: (t) => t.palette.background.paper,
                      borderRadius: "16px",
                      border: (t) => `1px solid ${t.palette.divider}`,
                    },
                    "& fieldset": { border: "none" },
                  },
                },
              }}
            />
          </LocalizationProvider>

          {/* <TextField
            size="small"
            placeholder="Search expenses / income"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            fullWidth
            sx={{
              minWidth: { xs: "100%", sm: 240 },
              "& .MuiOutlinedInput-root": {
                bgcolor: "white",
                borderRadius: "16px",
                border: "1px solid #ddf3ea",
              },
              "& fieldset": { border: "none" },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" />
                </InputAdornment>
              ),
            }}
          /> */}
        </Stack>
      </Stack>
    </Box>
  );
};

export default AccountsHeader;
